import React from 'react';
import {connect} from 'react-redux';
import {Row, Col, Modal} from 'react-bootstrap';
import StoreItemsList from '../../components/store/StoreItemsList';
import StoreCategoriesList from '../../components/store/StoreCategoriesList';
import {StoreTabsWrapper} from '../../components/store/StoreTabsWrapper';
import StoreCart from '../../components/store/StoreCart';
import UserMenu from '../common/UserMenu';
import SegmentsMenu from '../common/SegmentsMenu';
import MessagePage from '../../components/common/MessagePage';
import RecurringOrderItems from '../../containers/store/RecurringOrderItems';
import StoreSearch from "../../components/store/StoreSearch";
import {changeCategory} from '../../actions/store/storeCategoriesActions';
import {setAllowOrderEditToStore, setEditMultiOrder, setNextDeliveryDate} from '../../actions/common/subscriptionSummaryActions';
import {ORIGIN_CATEGORY_SELECTED, ORIGIN_ITEM_SELECTED, Messages} from '../../common/constants';
import {getRemainingCredits} from '../../common/basket';
import {dropDownClosed} from "../../actions/store/storeCheckoutActions";
import {translate} from '../../i18n/translate.js';
import {setShowUpdateRecurringModal, addRecurringItemsToOrder} from "../../actions/store/recurringOrderActions";
import {getUsefulDate} from "../../common/utils";
import styles from "../../css/store/storeItemsScreen.less";

class StoreItemsScreen extends React.Component {
    state = {
        category: null
    };

    componentDidMount() {
		this._loadLocation();

        if (this.props.hasMultiplePickupSites){
            if (this.props.isStoreClosedWithMultiOrders && this.props.pickupSiteParam){
                //In case of multiple delivery days don't show store close message - Show the next date
                this._allowEditMultiOrder();
            } else {
                const nextPickupSite = this.getPickupSiteForUpcomingDeliveryDate(this.props.multiplePickupSitesDates);
                if ((this.props.isStoreClosedWithMultiOrders && !this.props.pickupSiteParam) || (this.props.nextDeliveryDate !== nextPickupSite.date && !this.props.pickupSiteParam)) {
                    //Redirect to the the upcoming pickup site
                    this.setState({redirecting: true});
                    window.location.assign(location.pathname + "?p=" + nextPickupSite.key);
                }
            }
        }
	}

    componentDidUpdate() {
        this._loadLocation();
    }

    _loadLocation = () => {
        if(this.props.enterBy === ORIGIN_CATEGORY_SELECTED){
            const cKey = this.props.category || ((this.props.categories||[])[0]||{}).key ;
            if (cKey) {
                if (this.state.category !== cKey) {
                    this.setState({category: cKey});
                    this.props.changeCategory(cKey);
                }
            }
        }
        if(this.props.enterBy === ORIGIN_ITEM_SELECTED){
            const itemKey = this.props.itemKey;
            if(itemKey && itemKey !== this.state.itemKey){
                this.setState({itemKey: itemKey});
            }
        }

	};

    _allowAddingItems = () => {
        this.props.setAllowOrderEditToStore(true);
    };

    _allowEditMultiOrder = () => {
        this.props.setNextDeliveryDate(this.props.secondNextDeliveryDate);
        if(this.props.staticData.hasRecurringItems && !this.props.activeOrder) {
            this.props.addRecurringItemsToOrder(this.props.secondNextDeliveryDate);
        }
        this.props.setEditMultiOrder(true);
    };

    _shouldAllowOrderEdit = () => {
        return this.props.allowOrderEdit;
    };

    _getItemsNumberInRow = () => {
        if(this.props.clientViewPort.isMd || this.props.clientViewPort.isLg) {
            return 4; //desktop
        } else if(this.props.clientViewPort.isSm) {
                return 3; //desktop or tablet landscape
        }else if(this.props.clientViewPort.isXs){
            return 1; //mobile
        }else{
            return 2; //tablet portrait
        }
    };

    getUpdateRecurringModal = () => {
        if(this.props.showUpdateRecurringModal) {
            return (<Modal show={true} dialogClassName="update-recurring-items">
                <Modal.Body>
                    <RecurringOrderItems/>
                </Modal.Body>
            </Modal>);
        }
    };

    getPickupSiteForUpcomingDeliveryDate = (multiplePickupSitesDates) => {
        let pickupSite;
        let date = "3000-01-01";
        for (const pickupSiteDate in multiplePickupSitesDates){
            if (multiplePickupSitesDates.hasOwnProperty(pickupSiteDate))
                if (multiplePickupSitesDates[pickupSiteDate] < date){
                    date = multiplePickupSitesDates[pickupSiteDate];
                    pickupSite = pickupSiteDate;
                }
        }
        return {key:pickupSite, date};
    };

    render() {
        const itemsList = this.props.itemsList;
        let itemsInCategory = this.props.itemsInCategory;
        const itemsInRow = this._getItemsNumberInRow();
        const allowOrderEdit = this._shouldAllowOrderEdit();
        if(this.state.redirecting){
            return <div/>;
        }
        if (itemsList) {
            if (this.props.staticData.confirmEditExistingOrder && !allowOrderEdit) {
                const messageData = {
                    messageTitle: 'Add on to Your Existing Order',
                    messageBody: 'To add-on to your order leave existing items in the cart. After adding new items, click check-out to finalize your order'
                };
                return (
                    <MessagePage
                        messageData={messageData}
                        memberKey={this.props.memberDetails.memberKey}
                        action={{text: translate('Continue To Store'), callback: this._allowAddingItems, type: 'button'}}/>
                );
            }
            if(this.props.isStoreClosedWithMultiOrders && !this.props.editMultiOrder) {
                //In case of multiple delivery days don't show store close message
                if (this.props.hasMultiplePickupSites)
                    return <div/>;
                const messageData = {
                    messageTitle : Messages.STORE_CLOSED.title,
                    messageBody:
                        translate("_multiOrderStoreClosed")
                            .replace('{0}', getUsefulDate(this.props.nextDeliveryDates[0]))
                            .replace('{1}',getUsefulDate(this.props.nextDeliveryDates[1]))
                            .replace('{2}', this.props.staticData.farmEmail)
                };
                const linkText = (this.props.activeOrder ? 'Click to update your order for ':'Click to place order for ') + getUsefulDate(this.props.secondNextDeliveryDate);
                return (
                    <MessagePage
                        messageData={messageData}
                        memberKey={this.props.memberDetails.memberKey}
                        action={{text:linkText, callback:this._allowEditMultiOrder, type: 'button'}}/>
                );
            }
            if (!allowOrderEdit) {
                const messageData = {
                    messageTitle: translate("Order Exists"),
                    messageBody: translate("_haveOrderThatIsBeingProcessed")
                };

                return (
                    <MessagePage
                        messageData={messageData}
                        memberKey={this.props.memberDetails.memberKey}
                        action={{text: translate('Add Items'), callback: this._allowAddingItems}}/>
                );
            }
            if (this.props.clientViewPort.isXs) {
                return (<StoreTabsWrapper itemsList={itemsInCategory} allItems={itemsList} itemsInRow={itemsInRow}
                                          categories={this.props.categories}
                                          itemKey={this.props.itemKey} activeOrder={this.props.activeOrder}
                                          orderedItems={this.props.orderedItems}
                                          extraCreditItem={this.props.extraCreditItem}
                                          remainingCredits={getRemainingCredits(this.props.creditsData, this.props.totals)}
                                          remainingBalanceAsCredits={this.props.totals.orderTotal && this.props.totals.orderTotal.remainingBalanceAsCredits}
                                          nextDeliveryDate={this.props.nextDeliveryDate}
                                          staticData={this.props.staticData}
                                          totals={this.props.totals}
                                          isCreditItemAsRegularItem={this.props.isCreditItemAsRegularItem}
                                          creditItemLabel={this.props.creditItemLabel}
                                          multiplePickupSitesDates={this.props.multiplePickupSitesDates}
                                          showUpdateRecurringModal={this.props.showUpdateRecurringModal}/>);
            }
            return (
                <Row>
                    <Col md={2} sm={2} className="categories-wrapper">
                        <StoreCategoriesList categories={this.props.categories}/>
                    </Col>
                    <Col md={10} sm={10}>
                        <Row className="items-list-header">
                            <Col lg={6} md={7} sm={12} className="user-and-cart-wrapper">
                                {!this.props.preview ?
                                    <UserMenu />
                                    : this.props.staticData.segments.length > 0 ?
                                        <SegmentsMenu/>
                                        : undefined
                                }
                                <StoreCart items={itemsList}
                                           orderedItems={this.props.orderedItems}
                                           extraCreditItem={this.props.extraCreditItem}
                                           remainingCredits={getRemainingCredits(this.props.creditsData, this.props.totals)}
                                           totals={this.props.totals}
                                           staticData={this.props.staticData}
                                           isDropDownClosed={this.props.isDropDownClosed}
                                           isCreditItemAsRegularItem={this.props.isCreditItemAsRegularItem}
                                           creditItemLabel={this.props.creditItemLabel}
                                           showUpdateRecurringModal={this.props.showUpdateRecurringModal}
                                />
                            </Col>
                            <StoreSearch/>
                            <Col lg={6} md={5} sm={12} className="category-title">
                                <div id="categoryTitle" className="category-title-inner">{this.props.categoryName}</div>
                            </Col>
                        </Row>
                        <StoreItemsList className="items-container" itemsList={itemsInCategory}
                                        itemsInRow={itemsInRow} itemKey={this.props.itemKey}
                                        activeOrder={this.props.activeOrder}
                                        staticData={this.props.staticData}/>
                    </Col>
                    {this.getUpdateRecurringModal()}
                </Row>
            )
        } else {
            return (
                <Row>
                    <h1>No Items</h1>
                </Row>
            );
        }
    }
}

const mapStateToProps = (state, ownProps) => {
	const selectedCategory = (state.categories.find(c=>c.selected)||{}).key;
    const categoryName = (state.categories.find(c=>c.selected)||{title:''}).title;
    const extraCreditItem = ((state.storeCreditsData || {}).extraCreditItem || {});
	let itemsInCategory = {};
	for (let key in state.itemsList) {
        if (state.itemsList.hasOwnProperty(key)) {
            const item = state.itemsList[key];
            if (!item.variation && ((state.staticData.showUnavailableItemsInStore && (item.key !== extraCreditItem.key)) || item.available > 0) && (item.category === selectedCategory || (item.additionalCategories || []).includes(selectedCategory)))
                itemsInCategory[key] = Object.assign({}, {...item, category: selectedCategory});
        }
    }
    const summary = state.summary || {};
    const orderStatus = state.orderStatus||{};
    const multiplePickupSitesDates = (state.summary || {}).multiplePickupSitesDates;
	return {
        clientViewPort: (state.clientViewPort || {}),
		itemsList: state.itemsList,
		itemsInCategory: itemsInCategory,
		categories: state.categories,
        categoryName: categoryName,
        allowOrderEdit: summary.allowOrderEdit,
        orderedItems: orderStatus.orderedItems,
        activeOrder: orderStatus.activeOrder,
        isOrderChanged: orderStatus.isChanged,
        memberDetails: (state.memberDetails || {}),
        staticData: state.staticData,
        nextDeliveryDate: summary.nextDeliveryDate,
        totals: (orderStatus.totals || {}),
        creditsData: (state.storeCreditsData || {}),
        extraCreditItem,
        isCreditItemAsRegularItem: state.staticData.isCreditItemAsRegularItem,
        isMultipleActiveOrdersEnabled: state.staticData.isMultipleActiveOrdersEnabled,
        creditItemLabel: state.staticData.creditItemLabel,
        showUpdateRecurringModal: (state.recurringOrder||{}).showUpdateRecurringModal,
        preview: ((state.staticData || {}).params || {}).mode === 'preview',
        secondNextDeliveryDate: summary.secondNextDeliveryDate,
        editMultiOrder: summary.editMultiOrder,
        nextDeliveryDates: summary.nextDeliveryDates,
        hasClosedOrder: summary.hasClosedOrder,
        multiplePickupSitesDates: multiplePickupSitesDates,
        hasMultiplePickupSites: (state.summary || {}).hasMultiplePickupSites,
        pickupSiteParam: (state.staticData.params || {}).p
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeCategory: key => {
			dispatch(changeCategory(key));
		},
        setAllowOrderEditToStore: flag => {
            dispatch(setAllowOrderEditToStore(flag));
        },
        isDropDownClosed: isDropDownClosed => {
		    dispatch(dropDownClosed(isDropDownClosed));
        },
        setShowUpdateRecurringModal: showUpdateRecurringModal => {
		    dispatch(setShowUpdateRecurringModal(showUpdateRecurringModal));
        },
        setEditMultiOrder: edit => {
		    dispatch(setEditMultiOrder(edit));
        },
        setNextDeliveryDate: nextDeliveryDate => {
		    dispatch(setNextDeliveryDate(nextDeliveryDate));
        },
        addRecurringItemsToOrder: (deliveryDate) => {
		    dispatch(addRecurringItemsToOrder(deliveryDate));
        }
	}
};


export default connect(mapStateToProps, mapDispatchToProps)( StoreItemsScreen );



// WEBPACK FOOTER //
// ./src/containers/store/StoreItemsScreen.js